
import Box from '@mui/material/Box';
import MainAdminPage from './MainAdminPage';
import MainProvincialPublicHealth from './MainProvincialPublicHealth';


export default function MainAdminDocument() {
  return (
    <Box  
  sx={{
    // minHeight: "150vh",
    borderRadius: "20px",
    // marginTop: -10, // ปรับระยะห่างด้านบนตามต้องการ
    padding: '30px 5px 5px 5px', // เพิ่ม padding เพื่อให้เนื้อหาภายในมีพื้นที่มากขึ้น
    backgroundColor: "#f5f5f5", // ตัวอย่างสีพื้นหลัง
  }}
>

    {window.location.pathname==="/public-health"?<MainProvincialPublicHealth/>: <MainAdminPage />}
 
</Box>

  );
}